export default "__VITE_ASSET__BrKqqg9___"